import type { ReactNode } from 'react'
import { cx } from './cx'
import styles from './Pill.module.css'

export type PillTone = 'pending' | 'approved' | 'neutral' | 'rejected' | 'brand'

export function Pill({ tone = 'neutral', children }: { tone?: PillTone; children: ReactNode }) {
  return (
    <span className={cx(styles.pill, styles[tone])}>
      <span className={styles.dot} />
      {children}
    </span>
  )
}
